import { MINIMUM_DELIVERY_AMOUNT } from "@/utils/order";

export const errorMessages = {
  LESS_THAN_MINIMUM_DELIVERY_AMOUNT: (minimumAmount = MINIMUM_DELIVERY_AMOUNT) => ({
    type: "warning",
    message: `Delivery minimum amount is $${minimumAmount}, please add some more products.`,
  }),
};